import React from "react";
import { StaticImage } from "gatsby-plugin-image";

export const UCBerkeley = () => (
	<StaticImage
		loading="eager"
		src="./UCBerkeley_light.png"
		alt="UCBerkeley_light"
	/>
);
export const GAIntLabtag = () => (
	<StaticImage
		loading="eager"
		src="./GAIntLabtag_light.png"
		alt="GAIntLabtag_light"
	/>
);
export const Harvard = () => (
	<StaticImage
		loading="eager"
		src="./Harvard_light.png"
		alt="Harvard_light"
	/>
);
export const JunoTherapeutics = () => (
	<StaticImage
		loading="eager"
		src="./JunoTherapeutics_light.png"
		alt="JunoTherapeutics_light"
		style={{ transform: "scale(0.85)" }}
	/>
);
export const Medmira = () => (
	<StaticImage loading="eager" src="./medmira.png" alt="Medmira" />
);
export const MerckPharma = () => (
	<StaticImage
		loading="eager"
		src="./MerckPharma_light.png"
		alt="MerckPharma_light"
	/>
);
export const Nautilus = () => (
	<StaticImage
		loading="eager"
		src="./Nautilus_light.png"
		alt="Nautilus_light"
	/>
);
export const StanfordMedicine = () => (
	<StaticImage
		loading="eager"
		src="./StanfordMedicine_light.png"
		alt="StanfordMedicine_light"
	/>
);
export const ThermoFisher = () => (
	<StaticImage
		loading="eager"
		src="./ThermoFisher_light.png"
		alt="ThermoFisher_light"
	/>
);

export const AcertaPharma = () => (
	<StaticImage loading="eager" src="./AcertaPharma.png" alt="AcertaPharma" />
);
export const Bioextrax = () => (
	<StaticImage loading="eager" src="./Bioextrax.png" alt="Bioextrax" />
);
export const BioqualInc = () => (
	<StaticImage loading="eager" src="./BioqualInc.png" alt="BioqualInc" />
);
export const Cellectis = () => (
	<StaticImage loading="eager" src="./cellectis.png" alt="Cellectis" />
);
export const ColumbiaUniversityMedCenter = () => (
	<StaticImage
		loading="eager"
		src="./ColumbiaUniversityMedCenter.png"
		alt="ColumbiaUniversityMedCenter"
	/>
);
export const Dendreon = () => (
	<StaticImage loading="eager" src="./Dendreon.png" alt="Dendreon" />
);
export const FredHutch = () => (
	<StaticImage loading="eager" src="./FredHutch.png" alt="FredHutch" />
);

export const TurningPointTherapeutics = () => (
	<StaticImage
		loading="eager"
		src="./TurningPointTherapeutics.png"
		alt="TurningPointTherapeutics"
	/>
);
export const Tyra = () => (
	<StaticImage loading="eager" src="./Tyra.png" alt="Tyra" />
);
export const UCSFHealth = () => (
	<StaticImage loading="eager" src="./UCSFHealth.png" alt="UCSFHealth" />
);
export const Vaccinex = () => (
	<StaticImage loading="eager" src="./Vaccinex.png" alt="Vaccinex" />
);
export const BristolMyersSquibb = () => (
	<StaticImage
		loading="eager"
		src="./BristolMyersSquibb_light.png"
		alt="Bristol Myers Squibb logo"
	/>
);
export const AztraZeneca = () => (
	<StaticImage
		loading="eager"
		src="./AstraZeneca_light.png"
		alt="AstraZeneca"
	/>
);
export const Eurofins = () => (
	<StaticImage loading="eager" src="./Eurofins_light.png" alt="Eurofins" />
);
export const MIT = () => (
	<StaticImage
		loading="eager"
		src="./MIT_light.png"
		alt="MIT"
		style={{ transform: "scale(1.4)" }}
	/>
);
